<template>
	<div class="d-flex flex-column overflow-auto">
		<DialogBody>
			<ProfileDestinationSelector
				:travel-list="destinationList"
				:color-palette="colorPalette"
				:is-x-s="isXS"
				:placeholder="placeholder"
				@update-destinations="setDestinationList"
			/>
		</DialogBody>
		<DialogActions
			cancel-action
			:accept-action="{ text: $t('Common_Add_Button') }"
			:disable-accept="disableAccept"
			@accept="onAccept"
			@cancel="$emit('close')"
		/>
	</div>
</template>

<script setup lang="ts">
	import { ref, computed } from 'vue'
	import { storeToRefs } from 'pinia'
	import { useDeviceStore } from '~/store/device'
	import { Destination2 } from '~/models/Destination'
	import { Spot2 } from '~/models/Spot'

	const deviceStore = useDeviceStore()
	const { isXS } = storeToRefs(deviceStore)

	interface Props {
		placeholder?: string
		colorPalette?: 'primary' | 'secondary'
	}

	withDefaults(defineProps<Props>(), {
		placeholder: '',
		colorPalette: 'primary',
	})

	const emit = defineEmits(['accept', 'close'])

	const destinationList = ref<Record<string, Destination2 | Spot2>>({})

	const onAccept = () => {
		emit('accept', Object.values(destinationList.value))
	}

	const setDestinationList = (destinations: Record<string, Destination2 | Spot2>) => {
		destinationList.value = destinations
	}

	const disableAccept = computed(() => {
		const destinationKeys = Object.keys(destinationList.value)
		return !destinationKeys || destinationKeys.length === 0
	})
</script>
